import { Client } from 'aliyun-gateway-api';
import { saveAs } from 'file-saver';
import { APP_SETTINGS } from './config/app.json';
import { getKeyByValue } from './utils/helper';
import APICode from './config/api.json';
import uuid from './utils/uuid';

// import { store } from "store";
// import { logout } from "actions/user";

const axios = require('axios');

// 定义请求参数类型（增强类型提示）
interface PostV2Options {
  url: string;
  data?: any; // 替代原form，用于传递Raw JSON数据
  isFormData?: boolean; // 标记是否为文件上传（FormData）
  [key: string]: any; // 其他扩展参数
}

const isLocalhost = (url: string): boolean => {
  const host = new URL(url).hostname;

  return Boolean(
    host === 'localhost' ||
      // [::1] is the IPv6 localhost address.
      host === '[::1]' ||
      // 127.0.0.1/8 is considered localhost for IPv4.
      host.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
  );
};

const _successCallback = function (response: any): any {
  // console.log(response);
  if (
    typeof response.data !== 'undefined' &&
    !!('result' in response.data) &&
    parseInt(response.data.result) === 1
  ) {
    return response.data.data || response.data.result;
  }
  if (response.data.result === 24) {
    // store.dispatch(logout());
  }
  // 不再 throw 出 error
  if (response.data.result) {
    return response.data.data || response.data.result;
  }

  throw 'result' in response.data ? response.data : false;
};
const _errorCallback = function (error: any): any {
  console.log(error);

  let _msg: any = {
    result: 0,
    code: undefined,
    msg: undefined,
    data: undefined
  };
  if (error !== false && ['object', 'array'].indexOf(typeof error) > -1 && !!('result' in error)) {
    const code: any = getKeyByValue(APICode, error.result);
    _msg = {
      result: error.result,
      code: code || undefined,
      msg: code ? code || undefined : undefined, // ($rootScope.lang().api)[code]
      data: typeof error.data !== 'undefined' ? error.data : undefined
    };
  } else {
    console.error(error);
  }
  throw _msg;
};

const _client = new Client(APP_SETTINGS.AppKey, APP_SETTINGS.AppSecret);
// The browser replaces User-Agent after signing. Sign the value it actually sends.
if (typeof navigator !== 'undefined' && navigator.userAgent) {
  _client.ua = navigator.userAgent;
}

_client._get = _client.get;
_client._post = _client.post;

_client.uploadOSS = function (_permit: any, file: any): Promise<any> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.upload.addEventListener('progress', (e) => {
      if (e.lengthComputable) {
        //        console.log(e.loaded / e.total);
      }
    });
    xhr.upload.addEventListener('load', () => {
      //      console.log("uploaded");
    });
    xhr.onreadystatechange = function () {
      // Call a function when the state changes.
      if (this.readyState === XMLHttpRequest.DONE) {
        const ret: any = { code: this.status };
        if (this.status === 200) {
          ret.data = xhr.response;
          resolve(ret);
        } else {
          reject(ret);
        }
      }
    };
    xhr.open('PUT', _permit.sign_url);
    xhr.setRequestHeader('x-oss-callback', _permit['x-oss-callback']);
    xhr.overrideMimeType(file.type);
    xhr.setRequestHeader('Content-Type', '');
    xhr.responseType = 'json';
    xhr.send(file);
  })
    .then(_successCallback)
    .catch(_errorCallback);
};

_client.get = function (_opt: any, cache: any): any {
  if (_opt && isLocalhost(_opt)) {
    _opt = _opt
      .replace(`${process.env.REACT_APP_BASE_URL}`, `${process.env.REACT_APP_BASE_URL}/api`)
      .concat('.json');
    return axios
      .get(_opt, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      })
      .then((response: any) => response.data.data);
  }
  return _client._get(_opt).then(_successCallback).catch(_errorCallback);
};
_client.download = function (opt: any): any {
  return axios
    .get(opt.url, {
      headers: {
        ...opt.headers,
        'Device-Id': getUUID()
      },
      responseType: 'blob'
    })
    .then((p: any) => !p.data.result && saveAs(p.data, opt.fileName))
    .catch(_errorCallback);
};
_client.post = function (opt: any): any {
  if (!!opt && opt.url && isLocalhost(opt.url)) {
    return _client.get(opt.url);
  }
  const form: any = {
    ...opt.form,
    lang: getLang(),
    device_id: (!!opt.form && opt.form.device_id) || getUUID(),
    access_token: (!!opt.form && opt.form.access_token) || getUToken(),
    merchant_id: (!!opt.form && opt.form.merchant_id) || getMID()
  };
  // Missing values are left out of the form body, but the signer still adds the key.
  // verify_token rejects that mismatch with A403IS.
  Object.keys(form).forEach((key) => {
    if (form[key] === undefined) {
      delete form[key];
    }
  });
  const _opt: any = {
    ...opt,
    form
  };

  // console.log(_opt.form);

  if (opt.form instanceof FormData) {
    opt.form.append('device_id', getUUID());
    return axios.post(opt.url, opt.form);
  }
  //  console.log("api-post", _opt);
  return _client._post(_opt).then(_successCallback).catch(_errorCallback);
};

_client.post_v2 = function (opt: PostV2Options): any {
  // 1. 本地地址兼容逻辑（和原post保持一致）
  if (!!opt && opt.url && isLocalhost(opt.url)) {
    return _client.get(opt.url);
  }

  // 2. 构建基础参数（公共参数：lang/device_id等）
  const commonParams = {
    lang: getLang(),
    device_id: (!!opt.data && opt.data.device_id) || getUUID(),
    access_token: (!!opt.data && opt.data.access_token) || getUToken(),
    merchant_id: (!!opt.data && opt.data.merchant_id) || getMID()
  };

  // 3. 区分处理：FormData文件上传 / Raw JSON
  const requestConfig: any = {
    url: opt.url,
    method: 'post',
    headers: { ...opt.headers } // 继承传入的header
  };

  // 场景2：Raw JSON格式（核心）- 强制使用 application/json
  requestConfig.headers['Content-Type'] = 'application/json';
  // 合并公共参数和业务参数，转为JSON字符串
  requestConfig.data = JSON.stringify({
    ...commonParams,
    ...opt.data // 业务Raw数据
  });

  // 4. 发送请求（复用原有的成功/失败回调）
  return axios(requestConfig);
};

export const client = _client;
function getLocal(key: string): string | boolean | null {
  return localStorage.getItem(key);
}

export function setLocal(key: string, value: string): string | boolean | null {
  if (!(value || '').trim()) {
    return delLocal(key);
  }
  localStorage.setItem(key, value);

  return localStorage.getItem(key);
}

function delLocal(key: string): boolean {
  localStorage.removeItem(key);
  return !localStorage.getItem(key);
}

export function setLang(i_lang: string): string | null | boolean {
  return setLocal('lang', i_lang);
}

export function getLang(): string | boolean {
  const ret = getLocal('i18nextLng') || 'zh';
  return ret;
}

export function getMID(): string | boolean | undefined {
  const ret = getLocal('merchant_id') || undefined;
  return ret;
}

export function setMID(i_token: string): string | boolean | null {
  return setLocal('merchant_id', i_token);
}

export function setUToken(i_token: string): string | boolean | null {
  return setLocal('access_token', i_token);
}

export function getUToken(): string | boolean | undefined {
  const ret = getLocal('access_token') || undefined;
  return ret;
}

export function getUUID(): string | boolean | null {
  if (!getLocal('uuid')) {
    const device_id = uuid();
    setLocal('uuid', device_id);
    return device_id;
  }
  return getLocal('uuid');
}

const ret = {
  client
};

export default ret;
